
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/[slug]",
      function () {
        return require("private-next-pages/partners/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/[slug]"])
      });
    }
  